module.exports = __webpack_public_path__ + "media/iphone_notification.537acd63.mp3";